import React, { Component } from "react";

import Logo from "./../../shared/logo";
import Navigation from "./../../shared/navigation";
import UserState from "./../../shared/userState";

import styles from "./sideHead.module.scss";
import { withDownloadFiles } from "../../shared/containers/containerDownloadFiles";
import Preloader from "../../shared/items/static/preloader";
import { states } from "../../reducers/queriesStates";

class SideHead extends Component {
  onDownloadClickHandler() {
    const { onDownloadHelpFile, downloadHelpFileDataState } = this.props;

    if (downloadHelpFileDataState !== states.REQUEST) {
      onDownloadHelpFile({ format: 0, category: 0 });
    }
  }

  render() {
    const { downloadHelpFileDataState } = this.props;

    return (
      <div className={styles.sideHead}>
        <Logo />
        <div className={styles.container_navigation}>
          <Navigation />
        </div>

        <div className={styles.container_download_help_file}>
          <div
            className={styles.linkContainer}
            onClick={(e) => {
              e.stopPropagation();
              this.onDownloadClickHandler();
            }}
          >
            {downloadHelpFileDataState === states.REQUEST ? (
              <div style={{ paddingRight: "80px" }}>
                <Preloader />
              </div>
            ) : (
              <span>РУКОВОДСТВО ПОЛЬЗОВАТЕЛЯ</span>
            )}
          </div>
        </div>

        <div className={styles.container_userState}>
          <UserState />
        </div>
      </div>
    );
  }
}

export default withDownloadFiles(React.memo(SideHead));
